'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from 'react';
import type { HeroSlidePlayback, RegisterHeroPlayUnlock } from '@/app/lcv/components/sections/spartan/engine/sections/hero-animation/shared/types';

// Registers once per mount; the callbacks themselves are read fresh on
// every call, so they always see the slide's current clip.
export const useHeroPlayUnlock = (register, playback) => {
  const $ = _c(5);
  const playbackRef = useRef(playback);
  let t0;
  if ($[0] !== playback) {
    t0 = () => {
      playbackRef.current = playback;
    };
    $[0] = playback;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  useEffect(t0);
  let t1;
  let t2;
  if ($[2] !== register) {
    t1 = () => {
      if (!register) {
        return;
      }
      return register({
        unlock: isActive => playbackRef.current.unlock(isActive),
        isClipOnHand: () => playbackRef.current.isClipOnHand()
      });
    };
    t2 = [register];
    $[2] = register;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
};